import { render, staticRenderFns } from "./basicLayout.vue?vue&type=template&id=61b372d3&scoped=true&"
import script from "./basicLayout.vue?vue&type=script&lang=js&"
export * from "./basicLayout.vue?vue&type=script&lang=js&"
import style0 from "./basicLayout.vue?vue&type=style&index=0&id=61b372d3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b372d3",
  null
  
)

export default component.exports